import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import TpClientInvoiceService from '../../../Services/TpClientInvoiceService';
import ExportInvoicePdfsItem from '../../../Domain/ExportInvoicePdfsItem';

export default class ExportTpClientInvoicePdfsWindowDescription extends React.Component {
  static titleForEdit = 'Export Batch';
  static finishButtonLabel = 'Start Export';
  static itemType = ExportInvoicePdfsItem;
  static serviceFunction = (editedItem) =>
    TpClientInvoiceService.ExportInvoicePdfs(
      editedItem,
      ExportTpClientInvoicePdfsWindowDescription.getSearchParameters(),
      ExportTpClientInvoicePdfsWindowDescription.getSelected(),
      ExportTpClientInvoicePdfsWindowDescription.getAllItemsInTheSearchSetAreSelected()
    );

  static getSelected() {
    return null;
  }

  static getSearchParameters() {
    return null;
  }

  static getAllItemsInTheSearchSetAreSelected() {
    return null;
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'LatestVersion',
          label: 'Export Mode',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: ExportTpClientInvoicePdfsWindowDescription.getExportOptions(),
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    },
  ];

  static getExportOptions() {
    return [
      { value: null, label: ''},
      { value: 'false', label: 'Finalized Invoices'},
      { value: 'true', label: 'Latest Invoices'},
    ];
  }
}
